import React from "react";
import classNames from "classnames/bind";
import { CSSTransition } from "react-transition-group";
import s from "./index.module.scss";
const cx = classNames.bind(s);

const Preloader = ({ className, hide }) => (
	<CSSTransition
		in={hide}
		timeout={1300}
		classNames={{ ...s }}
		unmountOnExit
		appear
	>
		<span className={cx(s.preloader, className)} />
	</CSSTransition>
);

export default Preloader;
